<template>
  <button
      class="relative flex items-center gap-[4px] leading-7 w-fit h-fit py-0.5 px-2 text-white text-base font-bold bg-error rounded"
      @click="toggleTooltip"
  >
    <span class="material-symbols-rounded text-white text-lg">error</span>
    <span>
      <slot></slot>
    </span>
    <tooltip-missing-product
        v-if="showTooltip"
        :items="items"
        :positionBottom="true"
        class="!absolute z-10 left-0 bottom-[49px]"
    ></tooltip-missing-product>
  </button>
</template>

<script>
import TooltipMissingProduct from "@/components/Global/TooltipMissingProduct.vue";

export default {
  name: "button-tooltip-error-hayadata",
  components: {TooltipMissingProduct},
  props: {
    items: Array,
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  methods: {
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
      if (this.showTooltip) {
        document.addEventListener("click", this.hideTooltipOutside);
      } else {
        document.removeEventListener("click", this.hideTooltipOutside);
      }
    },
    hideTooltipOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showTooltip = false;
        document.removeEventListener("click", this.hideTooltipOutside);
      }
    },
  },
};
</script>

<style>
</style>